export class AsyncSectionNavigator {
  private activeController: AbortController | null = null;

  abort(): void {
    if (this.activeController) {
      this.activeController.abort();
      this.activeController = null;
    }
  }

  async run<T>(fetcher: (signal: AbortSignal) => Promise<T>): Promise<T> {
    this.abort();
    this.activeController = new AbortController();
    const { signal } = this.activeController;

    try {
      return await fetcher(signal);
    } finally {
      if (this.activeController && this.activeController.signal === signal) {
        this.activeController = null;
      }
    }
  }
}

